import React, { PropsWithChildren } from 'react';

interface Props {
  condition: boolean;
  fallback?: React.ReactNode;
}

const When: React.FC<PropsWithChildren<Props>> = ({ condition, children, fallback = null }) => {
  return !!condition ? children : fallback;
};

export default When;
